﻿/**
 * On a wide screen every menu shows up at full size and closes at once,
 * the same as Nintendo, Playstation, Xbox, and Sega.
 * Narrower screens still grow the chip and the list together, then play
 * that motion backward on close.
 * The row under the pointer stays quiet for a brief moment after open,
 * then it can be clicked without moving to another row.
 * Trailing reserve padding is applied in a sync header script (first paint).
 */
(function () {
  var lastPointer = { x: 0, y: 0, down: false };

  document.addEventListener(
    'pointerdown',
    function (event) {
      lastPointer.down = true;
      lastPointer.x = event.clientX;
      lastPointer.y = event.clientY;
    },
    true
  );
  document.addEventListener(
    'pointerup',
    function (event) {
      lastPointer.down = false;
      lastPointer.x = event.clientX;
      lastPointer.y = event.clientY;
    },
    true
  );
  document.addEventListener(
    'pointermove',
    function (event) {
      lastPointer.x = event.clientX;
      lastPointer.y = event.clientY;
    },
    true
  );

  function reduceMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function isWideDesktop() {
    return window.matchMedia('(min-width: 1200px)').matches;
  }

  function isWideColumns(details) {
    if (!details) return false;
    var submenu = details.querySelector(':scope > .header__submenu');
    if (!submenu || !submenu.classList.contains('ri-header-submenu--columns')) return false;
    return isWideDesktop();
  }

  function openColumnLinks(details) {
    if (!isWideColumns(details)) return;
    details.querySelectorAll('.ri-header-flyout').forEach(function (fly) {
      fly.open = true;
    });
  }

  /* After the first paint, open the column lists once so a click does not build them. */
  function syncColumnLinks() {
    var wide = window.matchMedia('(min-width: 1200px)').matches;
    document.querySelectorAll('.header--ri .ri-header-submenu--columns .ri-header-flyout').forEach(function (fly) {
      if (wide) {
        fly.open = true;
        return;
      }
      var parent = fly.closest('header-menu > details');
      if (!parent || !parent.open) fly.open = false;
    });
  }

  function armColumnLinks() {
    var start = function () {
      window.requestAnimationFrame(function () {
        window.setTimeout(syncColumnLinks, 0);
      });
    };
    if (document.readyState === 'complete') start();
    else window.addEventListener('load', start, { once: true });
    window.matchMedia('(min-width: 1200px)').addEventListener('change', syncColumnLinks);
  }

  function placeColumns(details) {
    var submenu = details && details.querySelector(':scope > .header__submenu');
    if (!submenu) return;
    if (!isWideColumns(details)) {
      submenu.style.left = '';
      submenu.style.removeProperty('width');
      submenu.style.removeProperty('max-width');
      return;
    }
    /* A console family sheet sits under its own word and sizes to its systems; it only shifts left
       when it would run off the right edge. */
    submenu.style.removeProperty('width');
    submenu.style.removeProperty('max-width');
    shiftPanel(submenu);
  }

  /* Keep a wide list on screen without stretching the button. */
  function shiftPanel(submenu) {
    if (!submenu) return;
    submenu.style.left = '0px';
    var rect = submenu.getBoundingClientRect();
    var limit = window.innerWidth - 12;
    if (rect.right > limit) submenu.style.left = (limit - rect.right) + 'px';
    if (submenu.getBoundingClientRect().left < 8) submenu.style.left = '0px';
  }

  function measureSubmenuWidth(submenu) {
    if (submenu._riMeasuredW) return submenu._riMeasuredW;
    var clone = submenu.cloneNode(true);
    clone.style.cssText =
      'position:absolute;visibility:hidden;display:flex;flex-direction:column;height:auto;width:max-content;max-width:none;min-width:0;left:-9999px;top:0;pointer-events:none;margin:0;padding:0 0 0.15rem;border:2px solid #000;border-top:0;box-sizing:border-box;';
    document.body.appendChild(clone);
    clone.querySelectorAll('.ri-header-flyout__panel').forEach(function (panel) {
      panel.style.display = 'none';
    });
    var width = Math.ceil(clone.getBoundingClientRect().width);
    clone.remove();
    submenu._riMeasuredW = width;
    return width;
  }

  function naturalWidth(details, summary) {
    if (details.dataset.riNaturalWidth) {
      return parseFloat(details.dataset.riNaturalWidth);
    }
    var prevDetailsWidth = details.style.width;
    var prevSummaryWidth = summary.style.width;
    details.style.width = 'max-content';
    summary.style.width = '';
    var width = Math.ceil(summary.getBoundingClientRect().width);
    details.style.width = prevDetailsWidth;
    summary.style.width = prevSummaryWidth;
    details.dataset.riNaturalWidth = String(width);
    return width;
  }

  /* Widths are measured once per open and cached. A resize or a font swap
     clears the cache so the next open measures again. */
  var widthResetTimer = 0;
  function resetMenuWidths() {
    document.querySelectorAll('.header--ri header-menu > details').forEach(function (details) {
      if (details.open) return;
      delete details.dataset.riNaturalWidth;
      var submenu = details.querySelector(':scope > .header__submenu');
      if (submenu) submenu._riMeasuredW = 0;
    });
  }
  function scheduleMenuWidthReset() {
    window.clearTimeout(widthResetTimer);
    widthResetTimer = window.setTimeout(resetMenuWidths, 150);
  }

  function settle(details) {
    if (!details.open || details.dataset.riClosing === '1') return;
    var submenu = details.querySelector(':scope > .header__submenu');
    details.classList.add('ri-menu-settled');
    if (submenu) {
      submenu.style.overflow = '';
      submenu.style.maxHeight = '';
      submenu.style.transition = '';
    }
    if (!details.classList.contains('ri-menu-ready')) return;
    var row = rowAt(details, lastPointer.x, lastPointer.y);
    var flyout = row && row.closest('.ri-header-flyout');
    if (isWideColumns(details)) {
      placeColumns(details);
      return;
    }
    if (flyout && !flyout.open) revealFlyout(flyout);
  }

  function stopGrow(details) {
    if (details._riGrow) {
      details._riGrow.forEach(function (anim) {
        anim.cancel();
      });
      details._riGrow = null;
    }
  }

  function dropHeight(summary, submenuHeight) {
    var chip = Math.round(summary.getBoundingClientRect().height);
    return Math.max(chip, Math.round(chip + submenuHeight - 4));
  }

  /* The plate follows the live submenu box, in whole pixels, so the 4px offset never thickens. */
  function bindPlate(details, summary, submenu, anim) {
    var tick = function () {
      if (!submenu.isConnected) return;
      var h = submenu.getBoundingClientRect().height;
      details.style.setProperty('--ri-drop-h', dropHeight(summary, h) + 'px');
      if (anim && anim.playState === 'running') requestAnimationFrame(tick);
    };
    tick();
  }

  function expand(details) {
    var summary = details.querySelector(':scope > summary');
    var submenu = details.querySelector(':scope > .header__submenu');
    if (!summary || !submenu) return;

    if (details._riCloseTimer) {
      window.clearTimeout(details._riCloseTimer);
      details._riCloseTimer = null;
    }
    stopGrow(details);
    delete details.dataset.riClosing;
    details.classList.remove('ri-menu-closing');
    if (submenu) submenu.style.height = '';

    var columns = isWideColumns(details);
    if (columns) {
      openColumnLinks(details);
      details.style.width = '';
      summary.style.width = '';
      submenu.style.width = '';
      submenu.style.minWidth = '';
      submenu.style.maxHeight = '';
      submenu.style.height = '';
      submenu.style.overflow = '';
      submenu.style.transition = '';
      submenu.style.visibility = '';
      details.style.setProperty('--ri-drop-h', dropHeight(summary, 0) + 'px');
      details.classList.add('ri-menu-shown');
      placeColumns(details);
      submenu.getAnimations().forEach(function (anim) { anim.cancel(); });
      settle(details);
      return;
    }

    /* Same show-at-once open as the system menus. The button stays its own width. */
    if (isWideDesktop()) {
      details.classList.remove('ri-menu-settled');
      details.style.overflow = 'visible';
      details.style.transition = 'none';
      details.style.width = '';
      summary.style.width = '';
      submenu.style.boxSizing = 'border-box';
      submenu.style.width = '';
      submenu.style.minWidth = '';
      submenu.style.maxWidth = '';
      submenu.style.transition = 'none';
      submenu.style.maxHeight = 'none';
      submenu.style.height = '';
      submenu.style.overflow = '';
      submenu.style.visibility = '';
      details.style.setProperty('--ri-drop-h', dropHeight(summary, 0) + 'px');
      details.classList.add('ri-menu-shown');
      submenu.getAnimations().forEach(function (anim) { anim.cancel(); });
      shiftPanel(submenu);
      settle(details);
      return;
    }
    var base = naturalWidth(details, summary);
    var subW = columns ? base : measureSubmenuWidth(submenu);
    var target = columns ? base : Math.max(base, subW);

    details.classList.remove('ri-menu-settled');
    details.style.overflow = 'visible';
    details.style.transition = 'none';
    summary.style.boxSizing = 'border-box';
    summary.style.width = '100%';
    submenu.style.boxSizing = 'border-box';
    submenu.style.width = '100%';
    submenu.style.minWidth = '0';
    submenu.style.transition = 'none';

    details.style.width = target + 'px';
    submenu.style.maxHeight = 'none';
    submenu.style.overflow = 'hidden';
    var full = Math.ceil(submenu.scrollHeight);
    if (full < 1) full = Math.ceil(submenu.getBoundingClientRect().height);

    var shadowStart = dropHeight(summary, 0);
    var shadowEnd = dropHeight(summary, full);
    details.style.setProperty('--ri-drop-h', shadowStart + 'px');

    if (reduceMotion()) {
      details.style.width = target + 'px';
      submenu.style.maxHeight = 'none';
      submenu.style.overflow = '';
      details.style.setProperty('--ri-drop-h', (columns ? dropHeight(summary, 0) : shadowEnd) + 'px');
      details.classList.add('ri-menu-shown');
      settle(details);
      return;
    }

    submenu.style.maxHeight = '0px';
    details.style.width = base + 'px';
    details.classList.add('ri-menu-shown');

    var easing = 'cubic-bezier(0.16, 1, 0.3, 1)';
    var opts = { duration: 340, easing: easing, fill: 'forwards' };
    var heightAnim = submenu.animate(
      [{ maxHeight: '0px', offset: 0 }, { maxHeight: full + 'px', offset: 1 }],
      opts
    );
    var widthAnim = details.animate(
      [{ width: base + 'px' }, { width: target + 'px' }],
      opts
    );
    details._riGrow = [heightAnim, widthAnim];
    if (!columns) bindPlate(details, summary, submenu, heightAnim);
    Promise.all([heightAnim.finished, widthAnim.finished])
      .then(function () {
        if (!details.open || details.dataset.riClosing === '1') return;
        if (details._riGrow && details._riGrow[0] === heightAnim) {
          heightAnim.commitStyles();
          widthAnim.commitStyles();
          heightAnim.cancel();
          widthAnim.cancel();
          details._riGrow = null;
        }
        details.style.width = target + 'px';
        if (columns) {
          submenu.style.maxHeight = '';
          submenu.style.overflow = '';
          details.style.setProperty('--ri-drop-h', dropHeight(summary, 0) + 'px');
          placeColumns(details);
        } else {
          details.style.setProperty('--ri-drop-h', dropHeight(summary, submenu.getBoundingClientRect().height) + 'px');
        }
        settle(details);
      })
      .catch(function () {});
  }

  function cleanupClosed(details) {
    var summary = details.querySelector(':scope > summary');
    var submenu = details.querySelector(':scope > .header__submenu');
    details.style.width = '';
    details.style.overflow = '';
    details.style.removeProperty('--ri-drop-h');
    details.style.removeProperty('--ri-drop-full');
    details.style.transition = '';
    details.classList.remove('ri-menu-shown');
    details.classList.remove('ri-cols-ready');
    details.classList.remove('ri-menu-settled');
    details.classList.remove('ri-menu-quiet');
    details.classList.remove('ri-menu-ready');
    details.classList.remove('ri-menu-closing');
    if (summary) summary.style.width = '';
    if (submenu) {
      submenu.style.width = '';
      submenu.style.minWidth = '';
      submenu.style.left = '';
      submenu.style.maxHeight = '';
      submenu.style.height = '';
      submenu.style.overflow = '';
      submenu.style.transition = '';
      submenu.style.visibility = '';
      submenu.style.pointerEvents = '';
      submenu.getAnimations().forEach(function (anim) { anim.cancel(); });
    }
    stopGrow(details);
    delete details.dataset.riClosing;
  }

  function closeAnimated(details) {
    if (!details.open) return;
    if (details.dataset.riClosing === '1') return;

    var summary = details.querySelector(':scope > summary');
    var submenu = details.querySelector(':scope > .header__submenu');
    if (isWideDesktop()) {
      disarmMenu(details);
      if (!isWideColumns(details)) {
        details.querySelectorAll('.ri-header-flyout[open]').forEach(function (flyout) {
          flyout.open = false;
        });
      }
      details.open = false;
      cleanupClosed(details);
      return;
    }
    details.dataset.riClosing = '1';
    details.classList.add('ri-menu-closing');
    disarmMenu(details);
    details.querySelectorAll('.ri-header-flyout[open]').forEach(function (flyout) {
      flyout.open = false;
    });

    var currentH = submenu ? Math.ceil(submenu.getBoundingClientRect().height) : 0;
    var currentW = Math.ceil(details.getBoundingClientRect().width);
    var base = summary ? naturalWidth(details, summary) : currentW;
    stopGrow(details);

    if (!submenu || reduceMotion() || currentH < 2) {
      details.open = false;
      cleanupClosed(details);
      return;
    }

    submenu.style.overflow = 'hidden';
    submenu.style.maxHeight = 'none';
    submenu.style.boxSizing = 'border-box';
    submenu.style.transition = 'none';
    details.style.transition = 'none';
    details.style.width = currentW + 'px';
    submenu.style.height = currentH + 'px';

    details.style.setProperty('--ri-drop-h', dropHeight(summary, currentH) + 'px');

    var finished = false;
    var started = performance.now();
    var duration = 280;
    var finish = function () {
      if (finished) return;
      finished = true;
      if (details._riCloseTimer) {
        window.clearTimeout(details._riCloseTimer);
        details._riCloseTimer = null;
      }
      if (details.dataset.riClosing !== '1') return;
      submenu.style.height = '0px';
      details.style.width = base + 'px';
      details.style.setProperty('--ri-drop-h', dropHeight(summary, 0) + 'px');
      details.open = false;
      window.requestAnimationFrame(function () {
        cleanupClosed(details);
      });
    };
    var tick = function (now) {
      if (finished || details.dataset.riClosing !== '1') return;
      if (!details.open) details.open = true;
      var t = Math.min(1, (now - started) / duration);
      var k = t * t * (3 - 2 * t);
      var h = Math.max(0, Math.round(currentH * (1 - k)));
      var w = Math.round(currentW + (base - currentW) * k);
      submenu.style.height = h + 'px';
      details.style.width = w + 'px';
      details.style.setProperty('--ri-drop-h', dropHeight(summary, h) + 'px');
      if (t < 1) window.requestAnimationFrame(tick);
      else finish();
    };
    window.requestAnimationFrame(tick);
    details._riCloseTimer = window.setTimeout(finish, 360);
  }

  function disarmMenu(details) {
    details.classList.remove('ri-menu-ready');
    if (details._riQuietTimer) {
      window.clearTimeout(details._riQuietTimer);
      details._riQuietTimer = null;
    }
    if (details._riQuietUp) {
      document.removeEventListener('pointerup', details._riQuietUp, true);
      document.removeEventListener('pointercancel', details._riQuietUp, true);
      details._riQuietUp = null;
    }
    if (details._riQuietMove) {
      document.removeEventListener('pointermove', details._riQuietMove, true);
      details._riQuietMove = null;
    }
    var submenu = details.querySelector(':scope > .header__submenu');
    if (submenu) submenu.style.pointerEvents = '';
  }

  function rowAt(details, x, y) {
    var el = document.elementFromPoint(x, y);
    if (!el || !el.closest) return null;
    var item = el.closest('.header__menu-item');
    if (!item || !details.contains(item)) return null;
    var parentSummary = details.querySelector(':scope > summary');
    if (parentSummary && parentSummary.contains(item)) return null;
    return item;
  }

  function armMenu(details) {
    details.classList.remove('ri-menu-quiet');
    details.classList.add('ri-menu-ready');
    if (details._riQuietMove) {
      document.removeEventListener('pointermove', details._riQuietMove, true);
      details._riQuietMove = null;
    }
    if (details._riQuietUp) {
      document.removeEventListener('pointerup', details._riQuietUp, true);
      document.removeEventListener('pointercancel', details._riQuietUp, true);
      details._riQuietUp = null;
    }
    var submenu = details.querySelector(':scope > .header__submenu');
    if (submenu) submenu.style.pointerEvents = '';
  }

  function beginQuiet(details) {
    disarmMenu(details);
    if (details.dataset.riKeyOpen === '1') {
      details.classList.add('ri-menu-ready');
      return;
    }

    details.classList.add('ri-menu-quiet');
    var submenu = details.querySelector(':scope > .header__submenu');
    /* The opening click is already finished by the time the menu toggles.
       Hold clicks only while the button is still down, so that press cannot
       land on the first row. Once it is up, the row can be clicked. */
    if (lastPointer.down && submenu) submenu.style.pointerEvents = 'none';

    var arm = function () {
      if (!details.open || details.dataset.riClosing === '1') return;
      armMenu(details);
      if (isWideColumns(details)) return;
      var row = rowAt(details, lastPointer.x, lastPointer.y);
      var flyout = row && row.closest('.ri-header-flyout');
      if (flyout && !flyout.open) revealFlyout(flyout);
    };

    var release = function () {
      if (submenu) submenu.style.pointerEvents = '';
      if (details._riQuietTimer) window.clearTimeout(details._riQuietTimer);
      details._riQuietTimer = window.setTimeout(arm, 90);
    };

    if (!lastPointer.down) {
      release();
      return;
    }

    var onUp = function () {
      document.removeEventListener('pointerup', onUp, true);
      document.removeEventListener('pointercancel', onUp, true);
      details._riQuietUp = null;
      release();
    };
    details._riQuietUp = onUp;
    document.addEventListener('pointerup', onUp, true);
    document.addEventListener('pointercancel', onUp, true);
  }

  function onToggle(details) {
    if (details.dataset.riClosing === '1') return;
    if (details.open) {
      details.dataset.riOpenedAt = String(Date.now());
      beginQuiet(details);
      if (!isWideColumns(details)) {
        details.querySelectorAll('.ri-header-flyout[open]').forEach(function (flyout) {
          flyout.open = false;
        });
      }
      expand(details);
    } else {
      disarmMenu(details);
      cleanupClosed(details);
    }
  }

  function focusMenuPanel(details) {
    var panel = details.querySelector(':scope > .header__submenu');
    if (!panel) return;
    var target = panel.querySelector('a, button, summary');
    if (target) target.focus();
  }

  function firstFlyoutHref(details) {
    var first = details.querySelector('.ri-header-flyout__panel > li:not(.ri-header-flyout__photo) a[href]');
    return first ? first.href : '';
  }

  function finePointer() {
    return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }

  function goFlyout(details, event) {
    if (!finePointer()) {
      event.preventDefault();
      event.stopPropagation();
      details.open = !details.open;
      return;
    }
    var href = firstFlyoutHref(details);
    if (!href) return;
    event.preventDefault();
    event.stopPropagation();
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button === 1) {
      window.open(href, '_blank', 'noopener');
      return;
    }
    window.location.href = href;
  }

  /* Hover intent, mouse only. Resting on a menu word for a moment opens it; moving from one open menu
     to the next word switches after a short beat. Leaving the word and its panel closes it after a short grace,
     so a mouse that cuts a corner on the way to a row does not lose the menu. Click and keyboard still
     open and close it as before. */
  var HOVER_OPEN_MS = 140;
  var HOVER_CLOSE_MS = 260;
  /* A pointer that only grazes a word on its way into a wide panel (Nintendo spans three words) does not switch. */
  var HOVER_SWITCH_MS = 90;

  function clearHoverTimers(details) {
    if (details._riHoverOpenTimer) {
      window.clearTimeout(details._riHoverOpenTimer);
      details._riHoverOpenTimer = null;
    }
    if (details._riHoverCloseTimer) {
      window.clearTimeout(details._riHoverCloseTimer);
      details._riHoverCloseTimer = null;
    }
  }

  function otherOpenMenus(details) {
    return Array.prototype.filter.call(
      document.querySelectorAll('.header--ri header-menu > details[open]'),
      function (open) {
        return open !== details && open.dataset.riClosing !== '1';
      }
    );
  }

  function hoverOpen(details) {
    if (details.open && details.dataset.riClosing !== '1') return;
    var header = details.closest('.header--ri');
    if (header && header.classList.contains('ri-header--nav-collapsed')) return;
    otherOpenMenus(details).forEach(function (open) {
      clearHoverTimers(open);
      closeAnimated(open);
    });
    if (details.dataset.riClosing === '1') {
      if (details._riCloseTimer) {
        window.clearTimeout(details._riCloseTimer);
        details._riCloseTimer = null;
      }
      delete details.dataset.riClosing;
      details.dataset.riHoverOpen = '1';
      details.dataset.riOpenedAt = String(Date.now());
      expand(details);
      beginQuiet(details);
      return;
    }
    details.dataset.riHoverOpen = '1';
    details.open = true;
  }

  /* Console photos load lazily. Start them as soon as the pointer or keyboard reaches the word, so they
     are in by the time the panel opens instead of popping in after it. */
  function warmPhotos(details) {
    if (details._riPhotosWarm) return;
    details._riPhotosWarm = true;
    details.querySelectorAll('img.ri-header-flyout__photo-img[loading="lazy"]').forEach(function (img) {
      img.loading = 'eager';
    });
  }

  /* Best sellers strip at the foot of a family sheet (wide computers only). The family's All shelf is
     sorted best selling and holds only games in stock; its ri-menu-strip view returns the first few as
     list items. The list arrives once (a few KB); its covers load when the shopper heads for that word. */
  function loadBestSellers(details) {
    var slot = details.querySelector('.ri-hbs[data-ri-bestsellers]');
    if (!slot || window.innerWidth < 1200) return Promise.resolve(null);
    if (slot._riLoading) return slot._riLoading;
    var url = slot.getAttribute('data-ri-bestsellers');
    url += (url.indexOf('?') === -1 ? '?' : '&') + 'view=ri-menu-strip';
    slot._riLoading = fetch(url, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('strip');
        return response.text();
      })
      .then(function (html) {
        if (html.indexOf('ri-hbs__item') === -1) return null;
        var label = document.createElement('p');
        label.className = 'ri-hbs__label';
        label.textContent = 'Best sellers in ' + (slot.getAttribute('data-ri-family') || '');
        var list = document.createElement('ul');
        list.className = 'ri-hbs__list list-unstyled';
        list.setAttribute('role', 'list');
        list.innerHTML = html;
        slot.appendChild(label);
        slot.appendChild(list);
        slot.hidden = false;
        if (details._riStripEager) eagerStrip(details);
        return slot;
      })
      .catch(function () {
        slot._riLoading = null;
        return null;
      });
    return slot._riLoading;
  }

  function eagerStrip(details) {
    details._riStripEager = true;
    details.querySelectorAll('img.ri-hbs__img[loading="lazy"]').forEach(function (img) {
      img.loading = 'eager';
    });
  }

  /* The shopper is heading for this word: console photos, the strip, and the strip covers. */
  function warmFamily(details) {
    warmPhotos(details);
    eagerStrip(details);
    loadBestSellers(details);
  }

  /* On a wide mouse screen, warm every family's photos once the page has settled (about 30 photos of
     about 5KB each), so the first panel a shopper opens is already complete. The best sellers lists come
     too, without their covers. */
  function warmAllPhotosWhenIdle() {
    var run = function () {
      if (!finePointer() || window.innerWidth < 1200) return;
      document.querySelectorAll('.header--ri header-menu > details').forEach(function (details) {
        warmPhotos(details);
        loadBestSellers(details);
      });
    };
    var later = function () {
      window.setTimeout(function () {
        if ('requestIdleCallback' in window) window.requestIdleCallback(run, { timeout: 4000 });
        else run();
      }, 2500);
    };
    if (document.readyState === 'complete') later();
    else window.addEventListener('load', later, { once: true });
  }

  function bindHoverIntent(details) {
    details.addEventListener('focusin', function () {
      warmFamily(details);
    });
    details.addEventListener('pointerdown', function () {
      warmFamily(details);
    });
    details.addEventListener('mouseenter', function () {
      warmFamily(details);
      if (!finePointer() || window.innerWidth < 990) return;
      clearHoverTimers(details);
      if (details.open && details.dataset.riClosing !== '1') return;
      var delay = otherOpenMenus(details).length ? HOVER_SWITCH_MS : HOVER_OPEN_MS;
      details._riHoverOpenTimer = window.setTimeout(function () {
        details._riHoverOpenTimer = null;
        hoverOpen(details);
      }, delay);
    });
    details.addEventListener('mouseleave', function () {
      if (!finePointer() || window.innerWidth < 990) return;
      clearHoverTimers(details);
      if (!details.open || details.dataset.riClosing === '1') return;
      /* Opened with a click or the keyboard: that menu waits for a click, Escape, or focus to leave. */
      if (details.dataset.riHoverOpen !== '1') return;
      details._riHoverCloseTimer = window.setTimeout(function () {
        details._riHoverCloseTimer = null;
        if (details.open && details.dataset.riClosing !== '1') closeAnimated(details);
      }, HOVER_CLOSE_MS);
    });
  }

  function init() {
    document.querySelectorAll('.header--ri header-menu > details').forEach(function (details) {
      var summary = details.querySelector(':scope > summary');
      if (summary) {
        naturalWidth(details, summary);
        summary.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') details.dataset.riKeyOpen = '1';
        });
        summary.addEventListener('click', function (event) {
          if (event.button !== 0) return;
          clearHoverTimers(details);
          /* A menu the mouse just opened stays open when the shopper clicks its word. */
          if (details.open && details.dataset.riHoverOpen === '1' && Date.now() - Number(details.dataset.riOpenedAt || 0) < 900) {
            event.preventDefault();
            event.stopPropagation();
            return;
          }
          if (!details.open && details.dataset.riClosing !== '1') return;
          event.preventDefault();
          event.stopPropagation();
          if (details.dataset.riClosing === '1') {
            if (details._riCloseTimer) {
              window.clearTimeout(details._riCloseTimer);
              details._riCloseTimer = null;
            }
            delete details.dataset.riClosing;
            expand(details);
            beginQuiet(details);
            return;
          }
          closeAnimated(details);
        }, true);
      }
      bindHoverIntent(details);
      details.addEventListener('toggle', function (event) {
        if (event.target !== details) return;
        if (!details.open) delete details.dataset.riHoverOpen;
        onToggle(details);
        if (details.open && details.dataset.riKeyOpen === '1') {
          delete details.dataset.riKeyOpen;
          focusMenuPanel(details);
        }
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var flyout = document.querySelector('.header--ri header-menu > details[open] .ri-header-flyout[open]');
      if (flyout) {
        var columnParent = flyout.closest('header-menu > details');
        if (columnParent && isWideColumns(columnParent)) {
          closeAnimated(columnParent);
          return;
        }
        flyout.open = false;
        var flySummary = flyout.querySelector(':scope > summary');
        if (flySummary) flySummary.focus();
        return;
      }
      var menu = document.querySelector('.header--ri header-menu > details[open]');
      if (!menu) return;
      closeAnimated(menu);
      var menuSummary = menu.querySelector(':scope > summary');
      if (menuSummary) menuSummary.focus();
    });

    window.addEventListener('resize', scheduleMenuWidthReset);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(resetMenuWidths);
    initSideFlyouts();
    armColumnLinks();
    warmAllPhotosWhenIdle();
  }

  function placeFlyout(details) {
    var panel = details.querySelector('.ri-header-flyout__panel');
    if (!panel) return;

    details.classList.remove('ri-header-flyout--left');
    panel.style.top = '';
    panel.style.minHeight = '';

    var rect = panel.getBoundingClientRect();
    if (rect.right > window.innerWidth - 8) {
      details.classList.add('ri-header-flyout--left');
    }
  }

  function flyPanel(details) {
    return details.querySelector('.ri-header-flyout__panel');
  }

  function ensureFlyShell(details, panel) {
    var parent = panel.parentElement;
    if (parent && parent.classList.contains('ri-fly-shell')) return parent;
    var shell = document.createElement('div');
    shell.className = 'ri-fly-shell';
    panel.parentElement.insertBefore(shell, panel);
    shell.appendChild(panel);
    return shell;
  }

  function resetFlyoutPanel(panel) {
    if (!panel) return;
    var shell = panel.parentElement;
    var anim = shell && shell._riFlyAnim;
    if (anim) {
      anim.cancel();
      shell._riFlyAnim = null;
    }
    panel.style.clipPath = '';
    panel.style.width = '';
    panel.style.maxWidth = '';
    panel.style.minWidth = '';
    panel.style.overflow = '';
    panel.style.transition = '';
    if (shell && shell.classList.contains('ri-fly-shell')) {
      shell.style.width = '';
      shell.style.height = '';
      shell.style.overflow = '';
    }
  }

  function revealFlyout(details) {
    var panel = flyPanel(details);
    if (!panel) {
      details.open = true;
      return;
    }
    var shell = ensureFlyShell(details, panel);

    document.querySelectorAll('.header--ri .ri-header-flyout[open]').forEach(function (open) {
      if (open !== details) {
        resetFlyoutPanel(flyPanel(open));
        open.open = false;
      }
    });
    resetFlyoutPanel(panel);

    if (reduceMotion()) {
      details.open = true;
      placeFlyout(details);
      details.style.removeProperty('--ri-fly-h');
      return;
    }

    details.open = true;
    placeFlyout(details);
    var fullW = Math.ceil(panel.getBoundingClientRect().width);
    var fullH = Math.ceil(panel.getBoundingClientRect().height);
    details.style.setProperty('--ri-fly-h', fullH + 'px');
    panel.style.boxSizing = 'border-box';
    panel.style.overflow = 'hidden';
    panel.style.minWidth = '0px';
    panel.style.width = '100%';
    panel.style.maxWidth = 'none';
    panel.style.transition = 'none';
    shell.style.overflow = 'visible';
    shell.style.height = fullH + 'px';
    shell.style.width = fullW + 'px';
    var anim = shell.animate([{ width: '0px' }, { width: fullW + 'px' }], {
      duration: 220,
      easing: 'cubic-bezier(0.16, 1, 0.3, 1)',
      fill: 'forwards'
    });
    shell._riFlyAnim = anim;
    var clearGrow = function () {
      if (shell._riFlyAnim === anim) shell._riFlyAnim = null;
      anim.cancel();
      panel.style.width = '';
      panel.style.minWidth = '';
      panel.style.maxWidth = '';
      panel.style.overflow = '';
      panel.style.transition = '';
      shell.style.width = '';
      shell.style.height = '';
      shell.style.overflow = '';
    };
    anim.finished.then(clearGrow).catch(clearGrow);
  }

  function initSideFlyouts() {
    document.querySelectorAll('.header--ri .ri-header-flyout').forEach(function (details) {
      var summary = details.querySelector(':scope > summary');
      var go = summary && summary.querySelector('.ri-header-flyout__go');
      var href = firstFlyoutHref(details);
      if (go && href) go.href = href;

      var closeTimer;
      details.addEventListener('mouseenter', function () {
        if (!finePointer()) return;
        clearTimeout(closeTimer);
        var parentDetails = details.closest('header-menu > details');
        if (parentDetails && isWideColumns(parentDetails)) return;
        if (parentDetails && !parentDetails.open) return;
        if (parentDetails && parentDetails.dataset.riClosing === '1') return;
        if (parentDetails && !parentDetails.classList.contains('ri-menu-ready')) return;
        revealFlyout(details);
      });
      details.addEventListener(
        'click',
        function (event) {
          if (!event.target.closest('summary')) return;
          goFlyout(details, event);
        },
        true
      );
      details.addEventListener(
        'auxclick',
        function (event) {
          if (event.button !== 1) return;
          if (!event.target.closest('summary')) return;
          goFlyout(details, event);
        },
        true
      );
      if (summary) {
        summary.addEventListener('keydown', function (event) {
          if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
          var parentDetails = details.closest('header-menu > details');
          if (!parentDetails || !parentDetails.open) return;
          event.preventDefault();
          if (event.key === 'ArrowLeft') {
            details.open = false;
            return;
          }
          parentDetails.classList.add('ri-menu-ready', 'ri-menu-settled');
          parentDetails.classList.remove('ri-menu-quiet');
          revealFlyout(details);
          var link = details.querySelector('.ri-header-flyout__panel > li:not(.ri-header-flyout__photo) a[href]');
          if (link) link.focus();
        });
      }
      details.addEventListener('mouseleave', function () {
        if (!finePointer()) return;
        var parentDetails = details.closest('header-menu > details');
        if (parentDetails && isWideColumns(parentDetails)) return;
        closeTimer = setTimeout(function () {
          resetFlyoutPanel(flyPanel(details));
          details.open = false;
        }, 80);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
